import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { I18n } from "aws-amplify";
import { IconCheckDouble } from "@americanbible/uikit";
import {
  FormSection,
  SectionHeader
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";

const SuccessIcon = styled.div`
  display: inline-block;
  padding: 8px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => (theme.darkMode ? "white" : theme.primary)};
  width: 24px;
  height: 24px;
  margin: 16px 16px 16px 0;
`;

const Centerer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CustomSuccessSignUp = ({ theme }) => {
  const siteTheme = useContext(ThemeContext);

  console.log("siteTheme", siteTheme);
  return (
    <FormSection theme={theme}>
      <Centerer>
        <SuccessIcon>
          <IconCheckDouble
            color={siteTheme.darkMode ? "white" : siteTheme.primary}
          />
        </SuccessIcon>
        <SectionHeader theme={theme} style={{ marginBottom: 0 }}>
          {I18n.get("Successfully created account")}
        </SectionHeader>
      </Centerer>
    </FormSection>
  );
};
